<template>
  <div v-if="quoteDistribution.id">
    <b-card
      no-body
    >
      <div class="m-2">
        <div class="row">
          <div class="col-md-6">
            <table class="table table-bordered">
              <tr>
                <th>{{ $t('From Org') }}</th>
                <td> {{ $langName(quoteDistribution.from_org.name) }}</td>
              </tr>
              <tr>
                <th>{{ $t('Period') }}</th>
                <td> {{ quoteDistribution.period.admission_year + '-' + quoteDistribution.period.name }}</td>
              </tr>
              <tr>
                <th>{{ $t('Comment') }}</th>
                <td> {{ quoteDistribution.reject_info }}</td>
              </tr>
            </table>
          </div>
          <div class="col-md-6">
            <table class="table table-bordered">
              <tr>
                <th>{{ $t('Description') }}</th>
                <td> {{ quoteDistribution.about }}</td>
              </tr>
              <tr>
                <th>{{ $t('File') }}</th>
                <td>
                  <router-link
                    v-if="quoteDistribution.file"
                    :to="{ name: 'pdf-viewer', params: { url: quoteDistribution.file }}"
                  >
                    <feather-icon
                      icon="EyeIcon"
                      class="cursor-pointer"
                      size="16"
                    />
                  </router-link>
                </td>
              </tr>
              <tr>
                <th>{{ $t('Status') }}</th>
                <td>
                  {{ getStatus(quoteDistribution.status) }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </b-card>
    <component
      :is="getComponent()"
      :quote-distribution="quoteDistribution"
    />
  </div>
</template>

<script>
import {
  BCard, BLink, BTable, BTr, BTh,
} from 'bootstrap-vue'
import store from '@/store'
import Finance from '@/views/components/quote-distribution-components/Finance.vue'
import University from '@/views/components/quote-distribution-components/University.vue'

export default {
  components: {
    BCard,
    BLink,
    BTable,
    BTr,
    BTh,
    Finance,
    University,
  },
  props: {
    quoteDistribution: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getStatus(status) {
      return this.$store.getters['staticModule/getQuoteDistributionStatus'](status).name[this.$i18n.locale]
    },
    getComponent() {
      return this.quoteDistribution.from_org.type_org_id === this.orgTypeFinance ? 'finance' : 'university'
    },
  },
  setup() {
    const { orgTypeFinance } = store.state.staticModule
    return {
      orgTypeFinance,
    }
  },
}
</script>

<style scoped>

</style>
